import { jsx as r } from "react/jsx-runtime";
import { QueryClientProvider as u } from "@tanstack/react-query";
import { QraftContext as a, requestFn as l } from "@openapi-qraft/react";
import { queryClient as m } from "./create-provider.js";
const v = ({
  children: e,
  config: t
}) => {
  const {
    directus: { baseUrl: o, token: i }
  } = t;
  return /* @__PURE__ */ r(u, { client: m, children: /* @__PURE__ */ r(
    a.Provider,
    {
      value: {
        baseUrl: o,
        async requestFn(n, s) {
          return l(n, {
            ...s,
            headers: {
              Authorization: `Bearer ${i}`
            }
          });
        }
      },
      children: e
    }
  ) });
};
export {
  v as ElantilApiProvider
};
